import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import HomeBuyerPage from "@/pages/HomeBuyerPage";
import HomeBuyerAdvisoryPage from "@/pages/HomeBuyerAdvisoryPage";
import SaleAgreementReviewPage from "@/pages/SaleAgreementReviewPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/home-buyer" element={<HomeBuyerPage />} />
                  <Route path="/home-buyer/advisory-services" element={<HomeBuyerAdvisoryPage />} />
                  <Route path="/home-buyer/sale-agreement-review" element={<SaleAgreementReviewPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                </Routes>
                <Footer />
                <WhatsAppButton />
              </>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;